module.exports = "<div [ngClass]=\"mapPositionToClassName(position)\" *ngIf=\"this.isVisible\" [@animate]=\"'show'\">\n    {{ message }}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/toast/toast.component.html
// module id = 134
// module chunks = 0 1